import {
  Col,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Button,
} from '@oscar/theme';
import React, { useState, useEffect } from 'react';
import { useTable } from '@oscar/table';
import {
  ActionField,
  AsyncField,
  Field,
  useFormContext,
  withForm,
} from '@oscar/form';
import { APIS } from 'common/constants/endpoints';
import { isEmpty } from 'lodash';
import { handleMaxAutoComplete } from 'features/insulation/utils';

const { Option } = Select;

interface AddEditPopupProps {
  title: string;
  isVisible: boolean;
  handleCancel: () => void;
  labelConfirm?: string;
  typePopup: 'add' | 'edit';
  record?: any;
  actionTable?: any;
}

const AddEditPopup: React.FC<AddEditPopupProps> = ({
  title,
  isVisible,
  handleCancel,
  labelConfirm,
  typePopup,
  record,
  actionTable,
}) => {
  const [formContext] = useFormContext();
  const [table] = useTable();
  const insulationDetail =
    formContext.selectors?.getDataByKey('getServiceDetail') || {};

  const handleOnCancel = () => {
    handleCancel();
    formContext.form?.reset?.();
  };

  const showMessage = (code: number) => {
    if (code === 1) {
      notification['success']({
        message: 'Successfully!',
        description: `Service Provider has been ${
          typePopup === 'add' ? 'created' : 'edited'
        }`,
      });
    }
    if (code === 2) {
      notification['error']({
        message: `${
          typePopup === 'add' ? 'Create' : 'Edit'
        } Service provider Error`,
      });
    }
  };

  useEffect(() => {
    if (typePopup === 'edit') {
      formContext?.form?.setFieldsValue({
        id: record?.id,
        companyName: record?.companyName,
        applicableServices: record?.applicableServices,
        areas: record?.areas,
      });
    }
  });

  const validateForm = () => {
    const data = formContext.form?.getFieldsValue();
    return (
      isEmpty(data?.companyName) ||
      isEmpty(data?.applicableServices) ||
      isEmpty(data?.areas)
    );
  };

  return (
    <ActionField
      name={'serviceProvider'}
      request={{
        name: 'Save',
        url:
          typePopup === 'add'
            ? APIS.ADD_SERVICES_PROVIDER
            : APIS.UPDATE_SERVICES_PROVIDER,
        method: 'POST',
        transformRequest: (data: any) => {
          const { companyName, applicableServices, areas } = data;
          return {
            id: record?.id,
            companyName,
            applicableServices,
            areas,
          };
        },
      }}
      onResponseData={(res: any) => {
        showMessage(res?.code);
        if (res?.code === 1) {
          actionTable?.fetchData?.({});
          table?.methods?.fetchData?.({});
          handleOnCancel();
        }
      }}
    >
      {(actionProps: any) => {
        return (
          <Modal
            className="popup-custom"
            title={title}
            maskTransitionName=""
            visible={isVisible}
            onCancel={handleOnCancel}
            footer={[
              <Button size="middle" key="back" onClick={handleOnCancel}>
                Cancel
              </Button>,
              <Button
                className="btn-submit"
                size="middle"
                key="submit"
                onClick={() => {
                  actionProps.submitData();
                }}
                disabled={validateForm()}
              >
                {labelConfirm}
              </Button>,
            ]}
          >
            <Row className="user-popup-row" gutter={12}>
              <Col span={24}>
                <p className="label-normal">Company name</p>
                <Field
                  name={'companyName'}
                  normalize={(e: any) => handleMaxAutoComplete(e, 100)}
                >
                  <Input placeholder="Company name" maxLength={100} />
                </Field>
              </Col>
            </Row>

            <Row className="user-popup-row" gutter={12}>
              <Col span={24}>
                <p className="label-normal">Applicable Services</p>
                <Field name={'applicableServices'}>
                  <Select
                    size="large"
                    mode="multiple"
                    className="user-popup-select"
                    allowClear
                    placeholder="Select Applicable Service"
                  >
                    {insulationDetail?.applicableServices?.map(
                      (com: any, key: any) => (
                        <Option value={com.id} key={`${key}${com.id}`}>
                          {com.label}
                        </Option>
                      ),
                    )}
                  </Select>
                </Field>
              </Col>
            </Row>

            <Row className="user-popup-row" gutter={12}>
              <Col span={24}>
                <p className="label-normal">Area</p>
                <Field name={'areas'}>
                  <Select
                    size="large"
                    mode="multiple"
                    className="user-popup-select"
                    allowClear
                    placeholder="Select Area"
                  >
                    {insulationDetail?.area?.map((com: any, key: any) => (
                      <Option value={com.id} key={`${key}${com.id}`}>
                        {com.label}
                      </Option>
                    ))}
                  </Select>
                </Field>
              </Col>
            </Row>
          </Modal>
        );
      }}
    </ActionField>
  );
};

export default withForm<AddEditPopupProps>({
  name: 'insulationDetailAddEdit',
  preload: [
    {
      name: 'getServiceDetail',
      url: APIS.META_DATA_INSULATION_DETAIL,
      method: 'GET',
    },
  ],
})(AddEditPopup);
